export const filterOutClientAppointmentsWhichUrgent = () => (clientAppointments) => {
  return clientAppointments.filter((appointment) => appointment?.appointment_t?.urgent && !appointment?.appointment);
};

export const filterOutClientAppointmentsWhichTriage = () => (clientAppointments) => {
  return clientAppointments.filter((appointment) => appointment?.appointment_t?.triage && !appointment?.appointment);
};

export const filterOutClientAppointmentsWhichUnassigned = () => (clientAppointments) => {
  return clientAppointments.filter((appointment) => !appointment?.appointment_t?.coordinator);
};
